export default [
    // 球员首页
    {
        path: '/teamInfo/player',
        name: 'player',
        component: () => import("../views/teamInfo/player/index.vue"),
        redirect: '/teamInfo/player/material',
        children: [
            // 资料
            {
                path: "/teamInfo/player/material",
                name: "material",
                component: () => import('@/views/teamInfo/player/material.vue')
            },
            // 生涯
            {
                path: "/teamInfo/player/career",
                name: "career",
                component: () => import('@/views/teamInfo/player/career.vue')
            },
            // 数据
            {
                path: "/teamInfo/player/data",
                name: "data",
                component: () => import('@/views/teamInfo/player/data.vue')
            },
            // 动态
            {
                path: "/teamInfo/player/dynamic",
                name: "dynamic",
                component: () => import('@/views/teamInfo/player/dynamic.vue')
            }
        ]
    }
]
